import { makeStyles } from '@material-ui/core';
import { manewcoTokens, useManewcoTokens } from '@platform/plugin-platform-react';

const useStyles = makeStyles(theme => {
  const MANEWCO = manewcoTokens(theme);
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      fontFamily: MANEWCO.fontFamily,
      whiteSpace: 'nowrap',
    },
    brand: { fontSize: 27, fontWeight: 800, letterSpacing: -1.5, color: MANEWCO.text, lineHeight: 1.1 },
    sub: {
      fontSize: 9,
      fontWeight: 700,
      letterSpacing: 2,
      textTransform: 'uppercase',
      color: MANEWCO.textSecondary,
      marginTop: 3,
    },
  };
});

/** Logotype texte de la maquette « Clarté complète », en attendant le SVG officiel. */
export const LogoFull = () => {
  const classes = useStyles();
  const MANEWCO = useManewcoTokens();
  return (
    <span className={classes.root}>
      <span className={classes.brand} aria-label="manewco">
        ma<span style={{ color: MANEWCO.secondary }}>new</span>co
      </span>
      <span className={classes.sub}>Plateforme développeur</span>
    </span>
  );
};
